import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeImageWrapperSkeleton } from './TypeImageWrapper';

export interface TypeBlockImageWithPartialOverlayFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    image: EntryFieldTypes.EntryLink<TypeImageWrapperSkeleton>;
    paragraphText?: EntryFieldTypes.Text;
}

export type TypeBlockImageWithPartialOverlaySkeleton = EntrySkeletonType<
    TypeBlockImageWithPartialOverlayFields,
    'blockImageWithPartialOverlay'
>;
export type TypeBlockImageWithPartialOverlay<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockImageWithPartialOverlaySkeleton, Modifiers, Locales>;

export function isTypeBlockImageWithPartialOverlay<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockImageWithPartialOverlay<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockImageWithPartialOverlay';
}
